<template>
<router-link :to="content.link" class="nolink" v-if="content.title">
  <section :style="gradientStyle(content.color_1,content.color_2)">
  <v-container fluid class="py-6">
    <v-row justify="center" align="center">
      <v-col class="text-center" cols="8" sm="8" md="5" lg="4" xl="3">
        <div class="logo" :style="`background-image:url(${content.logo})`">
        </div>
      </v-col>
      <v-col class="text-center text-md-left" cols="12" sm="10" md="6" lg="6" xl="5">
        <h2 class=" mb-4 white--text">{{content.title}}</h2>
        <p class=" grey--text text--lighten-2">{{content.text |limit_100}}</p>
      </v-col>

    </v-row>
  </v-container>
  </section>

</router-link>

</template>
<script>
export default {
  name: "",
  methods: {
    gradientStyle(color_1, color_2) {
      return `background: ${color_1};background: -webkit-linear-gradient(to right, ${color_1}, ${color_2});background: linear-gradient(to right, ${color_1}, ${color_2})`
    }
  },
  computed: {
    content() {
      return this.$store.state.app.footer_banner;
    }
  },
  data: () => ({

  })
}
</script>
<style lang="scss" scoped>
.logo {
    width: 100%;
    height: 120px;
    background-size: contain;
    background-position: center;
}
@media only screen and (min-width: 960px) {
  .logo{
    height: 300px;
  }
}
.gradient-bg {
    background: -webkit-gradient(linear, left top, left bottom, from(#0067f4), to(#2bdadd));
    background: linear-gradient(#0067f4 0%,#0067f4 50%, #2bdadd 100%);
}
.headerbox {
    padding-top: 70px;
    padding-bottom: 70px;

    position: relative;
}
.headerbox::before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 85%;
    background-color: #fff;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 200px;
    -webkit-box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.16);
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.16);

}
</style>
